#import "~/graphql/fragments/Assets/DefaultImageAsset.graphql"

fragment ProjectHero on projectHero_Entry {
    title
    subtitle
    image {
        ... DefaultImageAsset
    }
    markermask
}
